<template>
  <!--footer-->
  <div class="footer_view">
    <div class="centre-width flex-b">
      <div class="contact_kind">
        <div class="contact_title">
          <div class="title_cn">联系方式</div>
          <div class="title_en">CONTACT US</div>
        </div>
        <div class="contact_list">
          <div class="item" style="padding-left: 0">
            <p>如有其他要求可 1V1 泳池工厂人工客服</p>
          </div>
          <div class="item" style="padding-left: 0">
            <p>工厂直销价/设备齐全/专业团队</p>
          </div>

          <!--<div class="item icon1">
            电话：181-6638-3737
          </div>
          <div class="item icon2">
            邮箱：1377038041@qq.com
          </div>
          <div class="item icon3">
            地址：重庆市江津区珞璜工业园B区10幢
          </div>-->

        </div>
      </div>
     <!-- <div class="qr_code_view">
        <el-image class="qr" :src="qrCode"></el-image>
        <p class="mt10">扫码在线咨询</p>
      </div>-->

      <!--我们与您联系-->
      <div class="contact_us">
        <p class="mb20">1V1 人工客服</p>
        <el-form>
          <el-form-item>
            <div class="flex-c contact_item">
              <div class="label">您的称呼：</div>
              <div class="content">
                <input type="text" v-model="message.name">
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="flex-c contact_item">
              <div class="label">您的电话：</div>
              <div class="content">
                <input type="text" v-model="message.mobile">
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="contact_btn flex-c-c" v-loading="sendLoading" @click="sendMessage">立即提交</div>
      </div>
      <!--我们与您联系 end-->
    </div>
  </div>
  <!--footer end-->
</template>

<script>
export default {
  name: 'footerView',
  data () {
    return {
      qrCode: require('@/assets/images/qr_code.png'),
      message: {
        name: '',
        mobile: '',
      },
      sendLoading: false,
    }
  },
  methods: {
    // 与我联系
    sendMessage(){
      var that = this;
      if(this.message.name === ''){
        this.$message.error("请填写您的称呼");
        return;
      }
      if(!this.utils.isMobile(this.message.mobile)){
        this.$message.error("手机号格式有误，请重新填写");
        return;
      }
      this.sendLoading = true;
      var param = {
        ...this.message
      };
      that.$http(that.api.add1V1, param, "与我联系").then(res => {
        this.sendLoading = false;
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.message = {
            name: '',
            mobile: '',
          }
        }else{
          this.$message.error(res.msg);
        }
      });
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/footer.vue